import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { api, errMsg } from "../../lib/api";
import { DevicesList } from "./DevicesList";

const input = "mt-1.5 h-11 w-full border border-white/15 bg-black/40 px-3 font-mono text-sm normal-case tracking-normal text-white focus:border-[#a259ff] focus:outline-none";
const lbl = "block font-mono text-[11px] uppercase tracking-widest text-slate-400";

export const AccountTab = () => {
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState(user?.email ?? "");
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next && next !== confirm) {
      toast.error("New passwords don't match");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-credentials", { current_password: current, new_email: email, new_password: next || null });
      setUser(data);
      setCurrent("");
      setNext("");
      setConfirm("");
      toast.success("Owner login updated");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
    <form onSubmit={submit} className="mt-6 max-w-xl space-y-4" data-testid="admin-account-form">
      <p className="text-sm text-slate-400">Change the email and password you use to sign in. Other signed-in devices will be logged out.</p>
      <label className={lbl}>Login email<input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="account-email-input" /></label>
      <label className={lbl}>New password (leave blank to keep)<input type="password" minLength={8} value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" className={input} data-testid="account-new-password-input" /></label>
      <label className={lbl}>Confirm new password<input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" className={input} data-testid="account-confirm-password-input" /></label>
      <label className={lbl}>Current password (required)<input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" className={input} data-testid="account-current-password-input" /></label>
      <button disabled={busy} className="flex h-12 items-center gap-2 bg-[#a259ff] px-8 font-mono text-xs font-bold uppercase tracking-widest text-black disabled:opacity-60" data-testid="account-save-button">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Save login
      </button>
    </form>
    <DevicesList />
    </>
  );
};
